export default {
  NAME: 'name',
  MESSAGE: 'message',
  DATA: 'data',
  USE_DEFAULT_BLOCK_LIST: 'useDefaultBlockList',
  BLOCKED_EMAIL_ADDRESSES: 'blockedEmailAddresses'
};